import { MenuDocs } from '../../types/section';
import rosterClient from '../clients/rosterClient';

export const getDocsSeccion = () => {
  return rosterClient.get<MenuDocs>('/api/Documentation/GetSections');
};
